export default {"src":"/_next/static/media/payment-apple-pay.5d5ee7e8.svg","height":51,"width":74,"blurWidth":0,"blurHeight":0};